<template>
    <router-view />
    <YuStepModel
        :isShowModel="isShowStepModel"
        @close="closeStepModel"
        v-if="isShowStepModel && !mobileDevice"></YuStepModel>

    <YuMobileStepModel
        :isShowModel="isShowStepModel"
        @close="closeStepModel"
        v-if="isShowStepModel && mobileDevice"></YuMobileStepModel>

    <YuFirstModel
        :isShowModel="isShowFirstModel"
        @close="closeFirstModel"
        @change="showGuideModel"></YuFirstModel>
    <YuModalRecharge :isShowModel="recharge"> </YuModalRecharge>

    <ToastContainer />
    <yjGlobalLoading/>
</template>

<script setup>
import { useSlots } from "vue";

const slots = useSlots();
console.log('version:', 'v.0.9.0-09-22-01')
import { useStore } from "vuex";
import ToastContainer from '@/components/global/ToastContainer.vue'
import yjGlobalLoading from "@/components/loading/yj-globalLoading.vue";
import YuFirstModel from "@/components/Yu-first-model.vue";

import YuGuide from "@/components/upload-step/Yu-guide.vue";

import YuModalRecharge from "./components/Yu-modal-recharge.vue";

import YuStepModel from "@/components/Yu-step-model.vue";

import YuMobileStepModel from "@/views/mobile/components/Yu-step-model.vue";

import { ref, watch, computed, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";

import { useMixinMobileDevice } from "@/mixins/mobileDevice";
const { mobileDevice, Orientation } = useMixinMobileDevice();

const router = useRouter();
const { proxy } = getCurrentInstance();
const store = useStore();
const isGuide = computed(() => store.state.app.isGuide);
const recharge = computed(() => store.state.user.recharge);
console.log(recharge.value);
const isShowGuideModel = ref(false);

const isShowFirstModel = ref(false);

const isShowStepModel = ref(false);

watch(
    () => store.state.file.uploadModel, // 监听 store 中的某个属性
    (newValue, oldValue) => {
        isShowStepModel.value = newValue;
        if (newValue) {
            if (isGuide.value) {
                console.log("自动上传");
                store.dispatch("app/setUpStep", 1); //是自动上传文档
            } else {
                store.dispatch("app/setUpStep", 0); //手动上传文档
                store.dispatch("app/setIsGuide", false);
            }
        }
    }
);

watch(
    () => isGuide.value, // 监听 store 中的某个属性
    (newValue, oldValue) => {
        console.log(newValue);
        console.log("newValue");
        isShowFirstModel.value = newValue;
    }
);

const closeStepModel = () => {
    store.dispatch("app/setUpStep", 0); //手动上传文档
    store.dispatch("app/setIsGuide", false);
    store.dispatch("file/upLoadModel", false);
    store.dispatch("file/setFileID", "");
};
const showGuideModel = () => {
    closeFirstModel();
    // closeGuideModel(2); //上传文档
};

const closeFirstModel = () => {
    isShowFirstModel.value = false;
};
const closeGuideModel = (num) => {
    isShowGuideModel.value = false;

    if (num == 1) {
        store.dispatch("app/setIsGuide", true);
    } else {
        store.dispatch("app/setIsGuide", false);
    }

    store.dispatch("file/upLoadModel", true);
};
</script>
<style lang="less">
@import "@/styles/01-style.less";
/* 设置根字体大小 */
// html,
// body {
//     font-size: 157px; /* 根据设计图比例设置 */
// }

// /*>=960,<1024的设备屏幕*/
// @media screen and (min-width: 680px) and (max-width: 1023px) {
//     html,
//     body {
//         font-size: 100px;
//     }
// }

// /*>=960,<1024的设备屏幕*/
// // @media screen and (min-width: 960px) and (max-width: 1023px) {
// //     html {
// //         font-size: 120px;
// //     }
// // }

// /*>=1024,<1280的设备屏幕*/
// @media screen and (min-width: 1024px) and (max-width: 1439px) {
//     html,
//     body {
//         font-size: 140px;
//     }
// }

// /*>=1440,<1680的设备屏幕*/
// @media screen and (min-width: 1440px) and (max-width: 1679px) {
//     html,
//     body {
//         font-size: 148px;
//     }
// }

// /*>=1680,<1920px的设备屏幕*/
// @media screen and (min-width: 1680px) {
//     html,
//     body {
//         font-size: 157px;
//     }
// }

::after,
::before {
    font-size: 16px;
}

body {
    font-family: Rubik, SF Pro Text, Arial, sans-serif, Mulish, Avenir,
        -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
        "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica,
        Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol" !important;
    color: rgba(49, 48, 46, 1);
    // overflow: hidden;
}

p,
dl,
ol,
ul {
    padding: 0;
    margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: 16px;
}
img {
    width: 100%;
    height: 100%;
}

/* 隐藏滚动条 */
/* 自定义滚动条轨道 */
::-webkit-scrollbar {
    width: 4px; /* 滚动条宽度 */
    height: 4px; /* 滚动条高度（横向滚动条） */
}

/* 自定义滚动条轨道的背景 */
::-webkit-scrollbar-track {
    background: #f1f1f1; /* 滚动条轨道颜色 */
    border-radius: 10px; /* 滚动条轨道的圆角 */
}

/* 自定义滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #888; /* 滚动条滑块颜色 */
    border-radius: 10px; /* 滚动条滑块的圆角 */
}

/* 滚动条滑块的悬停状态 */
::-webkit-scrollbar-thumb:hover {
    background: #555; /* 滚动条滑块悬停时的颜色 */
}

.ivu-modal-header,
.ivu-modal-footer {
    border-color: transparent !important;
}

.ivu-btn:active {
    border-color: transparent !important;
}
textarea::-webkit-resizer {
    display: none;
}
.ivu-modal-content {
    padding: 10px !important;
}
.ivu-form-item-content {
    height: 40px !important;
    line-height: 40px !important;
    .ivu-input {
        height: 40px !important;
        line-height: 40px !important;
    }

    .ivu-input-with-prefix {
        padding-left: 42px !important;
    }
    .ivu-input-suffix {
        padding-right: 42px !important;
    }
}

.ivu-message {
    z-index: 999999 !important;
}

.ivu-spin-fullscreen-wrapper {
    background: rgba(0, 0, 0, 0.3);
}

.animate {
    background: url("@/assets/loading.gif") no-repeat;
    width: 160px;
    height: 120px;
    background-size: 100%;
    color: #fff;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-size: 20px;
    margin-top: -150px;
}
.ivu-poptip-popper {
    z-index: 999 !important;
}
.YjPopper-icon {
    font-size: 16px;
}
.YjPopper-item-box {
    display: flex;
    padding: 4px;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    align-self: stretch;
    border-radius: 4px;
    background: #fff;
    width: 142px;
    box-shadow: 1px 4px 10px 0px rgba(216, 216, 216, 0.48);
    .item {
        color: rgba(49, 48, 46, 1);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 100%;
        cursor: pointer;
        display: flex;
        padding: 4px;
        align-items: center;
        align-self: stretch;
        .icon {
            font-size: 18px;
            color: rgba(49, 48, 46, 1);
            margin-right: 17px;
        }

        &:hover {
            background: rgba(242, 242, 243, 1);
        }
    }
}
.footer{
    .page {
        position: absolute;
        left: 0;
        text-align: center;
        margin-right: 90px;
        .body-lg-semibold;
    }
    .generate-btn {
        gap: var(--brand-scale-200);
        display: flex;
    }

}
</style>
